import { render, staticRenderFns } from "./business_info.vue?vue&type=template&id=23a304b1&scoped=true&"
import script from "./business_info.vue?vue&type=script&lang=ts&"
export * from "./business_info.vue?vue&type=script&lang=ts&"
import style0 from "./business_info.vue?vue&type=style&index=0&id=23a304b1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23a304b1",
  null
  
)

export default component.exports